import React from 'react';

const Instructions = () => {
  return (
    <div className="instructions">
      <h3>How to Play:</h3>
      <ul>
        <li>Click anywhere in the 3D area to push your car forward</li>
        <li><strong>Press TAB</strong> to push your car forward (keyboard control!)</li>
        <li>Faster clicking = higher TPS (Taps Per Second) = faster car movement</li>
        <li>Experience the race from a first-person perspective!</li>
        <li>Reach the finish line to win!</li>
        <li>Try to get there with the fewest clicks!</li>
      </ul>
      
      <div className="keyboard-controls">
        <h4>⌨️ Keyboard Controls:</h4>
        <ul>
          <li><strong>TAB</strong> - Push car forward</li>
          <li><strong>SPACE</strong> - Start/Resume game</li>
          <li><strong>ENTER</strong> - Start/Resume game</li>
          <li><strong>ESC</strong> - Reset game</li>
        </ul>
      </div>

      <div className="game-tips">
        <h4>💡 Game Tips:</h4>
        <ul>
          <li>You can switch tabs and the game will pause automatically</li>
          <li>Return to the tab to resume playing</li>
          <li>Use both mouse and keyboard for maximum efficiency!</li>
        </ul>
      </div>

      <div className="3d-features">
        <h4>🎮 3D Features:</h4>
        <ul>
          <li>First-person camera view</li>
          <li>3D car with realistic movement</li>
          <li>Dynamic road with moving lines</li>
          <li>Immersive environment with trees and sky</li>
          <li>Real-time progress tracking</li>
        </ul>
      </div>
    </div>
  );
};

export default Instructions;
